<template>
  <modal class="modalCG" @before-open="iphoneModalsSet" @before-close="closingModal" name="modalAddItemToCart" height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box addItemToCart">
      <div class="modal-header">
        <span class="close" @click.prevent="toggleModal()">
          <icon name="close" scale="2"></icon>
        </span>
      </div>
      <div class="modal-body" v-if="item">
        <div @click.prevent="toggleActiveInput" >
          <span class="font-bold">{{ item.name }}</span><br />
          <span>{{ 'Preis: ' + formatPrice(item, 'unit') + ' / ' + getTextFromUnit(item.unit) }}</span>
          <span class="block" v-if="item.max_stock !== null && item.max_stock !== -1 && item.current_stock >= 0" >{{ 'Verfügbar: ' + item.current_stock + getAmountLabel(item.unit) }}</span>
          <div class="form-field number">
            <label for="addToCart_amountInput">Menge:</label>
            <button @click.prevent="decreaseAmount" class="btn number-left">-</button>
            <span id="addToCart_spanInputSimulator" :class="['inputSimulator', inputActive ? 'hidden' : '']">{{ amount + ' ' + getAmountLabel(item.unit) }}</span>
            <input
                type="number"
                v-model="amount"
                :min="min"
                :max="getMaxForItem(item)"
                id="addToCart_amountInput"
                :class="inputActive ? '' : 'hidden'"
            />
            <button @click.prevent="increaseAmount" class="btn number-right">+</button>
          </div>
          <span>Gesamt: {{ formatPrice(item, 'bruttoSum') }}</span>
        </div>
        <button class="btn green submit" @click.prevent="addItem">Bestätigen</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus } from '@/assets/js/event-bus.js'
  import { mapGetters, mapActions } from 'vuex'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'addItemToCart',
    mounted () {
      EventBus.$on('toggleAddItemToCartModal', (item) => {
        this.toggleModal(item)
      })
      EventBus.$on('escKey', () => {
        this.showAddItemToCart = false
        this.$modal.hide('modalAddItemToCart')
      })
    },
    beforeDestroy () {
      EventBus.$off('toggleAddItemToCartModal')
      EventBus.$off('escKey')
    },
    mixins: [helpers, formatting],
    data () {
      return {
        showAddItemToCart: false,
        item: null,
        amount: 1,
        step: 1,
        min: 1,
        addToCartToast: null,
        inputActive: false
      }
    },
    methods: {
      ...mapActions([
        'addItemToCart',
        'getShopProduct'
      ]),
      toggleActiveInput (event) {
        if (event.target.id === 'addToCart_spanInputSimulator') {
          this.inputActive = true
          this.$nextTick(() => {
            document.getElementById('addToCart_amountInput').focus()
          })
        } else if (event.target.id !== 'addToCart_amountInput') {
          this.inputActive = false
        }
      },
      decreaseAmount () {
        this.amount = (this.amount - this.step) < this.min ? this.amount : (this.amount - this.step)
        this.item.price = this.calculatePriceFromUnit(this.amount, this.item.price_per_unit, this.item.unit)
      },
      increaseAmount () {
        this.amount = (this.amount + this.step) > this.getMaxForItem(this.item) ? this.amount : (this.amount + this.step)
        this.item.price = this.calculatePriceFromUnit(this.amount, this.item.price_per_unit, this.item.unit)
      },
      updatePrice () {
        if (isNaN(this.amount) || this.amount < this.min) {
          this.amount = this.getStartAmount(this.item.unit)
        } else {
          this.amount = Math.floor(this.amount)
        }
        this.item.price = this.calculatePriceFromUnit(this.amount, this.item.price_per_unit, this.item.unit)
      },
      closingModal () {
        this.showAddItemToCart = false
        this.iphoneModalsUnset()
      },
      toggleModal (item) {
        if (item) {
          this.amount = this.getStartAmount(item.unit)
          this.step = this.getStepAmount(item.unit)
          this.min = this.getStepAmount(item.unit)
          this.item = item
          this.item.price = this.calculatePriceFromUnit(this.amount, this.item.price_per_unit, this.item.unit)
        }
        this.showAddItemToCart = !this.showAddItemToCart
        this.showAddItemToCart ? this.$modal.show('modalAddItemToCart') : this.$modal.hide('modalAddItemToCart')
      },
      addItem () {
        const vm = this
        if (vm.isAuthenticated) {
          if (vm.amount > vm.getMaxForItem(vm.item)) {
            vm.$toasted.error('Dieses Produkt ist aktuell nicht in der gewünschten Menge vorrätig.', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'check'
            })
          } else {
            if (!this.addToCartToast) {
              this.addToCartToast = this.$toasted.info('Wird gespeichert...', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                icon: 'info'
              })
              vm.addItemToCart({
                shop: vm.item.shop.uid,
                user: vm.account.uid,
                item: {product_id: vm.item.uid, amount: vm.amount},
                cb: () => {
                  vm.amount = vm.getStartAmount(vm.item.unit)
                  vm.addToCartToast.goAway(100)
                  vm.addToCartToast = null
                  vm.$toasted.success(vm.item.name + ' --> im Warenkorb!', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    icon: 'check',
                    action: {
                      text: 'Zum Warenkorb',
                      push: {
                        name: 'cart'
                      }
                    }
                  })
                  vm.$modal.hide('modalAddItemToCart')
                },
                errorCb: (error) => {
                  vm.addToCartToast.goAway(100)
                  vm.addToCartToast = null
                  if (error.response && error.response.status === 406) {
                    vm.getShopProduct({
                      product: vm.item.uid,
                      cb (response) {
                        var message = response.current_stock > 0 ? 'Von diesem Produkt gibt es aktuell nur ' + response.current_stock + ' ' + vm.getAmountLabel(response.unit) + ' zu Verfügung.' : 'Dieses Produkt steht aktuell nicht zu Verfügung.'
                        vm.$toasted.error(message, {
                          theme: 'primary',
                          position: 'top-right',
                          duration: 10000,
                          action: {
                            text: 'X',
                            class: 'toastBtn',
                            onClick: (e, toastObject) => {
                              toastObject.goAway(0)
                            }
                          },
                          icon: 'close'
                        })
                      },
                      errorCb () {
                        vm.$toasted.error('Dieses Produkt ist aktuell nicht in der gewünschten Menge vorrätig.', {
                          theme: 'primary',
                          position: 'top-right',
                          duration: 10000,
                          action: {
                            text: 'X',
                            class: 'toastBtn',
                            onClick: (e, toastObject) => {
                              toastObject.goAway(0)
                            }
                          },
                          icon: 'close'
                        })
                      }
                    })
                  } else {
                    vm.$toasted.error('Ups, das hat nicht geklappt - bitte versuche es später nochmal!', {
                      theme: 'primary',
                      position: 'top-right',
                      duration: 10000,
                      action: {
                        text: 'X',
                        class: 'toastBtn',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                      icon: 'close'
                    })
                  }
                }
              })
            }
          }
        } else {
          this.showAddItemToCart = false
          EventBus.$emit('toggleLoginModal', () => {
            EventBus.$emit('toggleAddItemToCartModal', vm.item)
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth_get_account',
        isAuthenticated: 'auth_is_authenticated',
        maxPosibleStock: 'options_get_max_posible_stock'
      })
    },
    watch: {
      amount (val) {
        if (this.item) {
          this.updatePrice()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/AddItemToCart.vue